"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearStorage = clearStorage;
exports.default = Storage;
exports.getAllStorage = getAllStorage;
exports.setAllStorage = setAllStorage;
var storage = [];
var hashKeys = {};
var numKeys = 0;
function hashCode(s) {
  for (var i = 0, h = 0; i < s.length; i++) h = Math.imul(31, h) + s.charCodeAt(i) | 0;
  return h;
}
function Storage(hash) {
  var stack = hash || new Error().stack.toString().split('\n').splice(0, 3).join('\n');
  var key = hashCode(stack);
  if (hashKeys[key] === undefined) {
    hashKeys[key] = numKeys;
    ++numKeys;
  }
  var index = hashKeys[key];
  storage[index] = storage[index] || {};
  return storage[index];
}
function getAllStorage() {
  return storage;
}
function setAllStorage(newArray) {
  for (var i = 0; i < newArray.length; ++i) {
    for (var member in storage[i]) delete storage[i][member];
    for (var member in newArray[i]) storage[i][member] = newArray[i][member];
  }
}
function clearStorage() {
  for (var i = 0; i < storage.length; ++i) {
    for (var member in storage[i]) delete storage[i][member];
  }
}